import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    header: {
      padding: "24px 26px",
      borderRadius: "16px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    center: {
      display: "flex",
      alignItems: "center"
    },
    headerItem: {
      display: "flex",
      marginBottom: 18
    },
    headerTitle: {
      minWidth: 128
    },
    mainColor: {
      color: theme.palette.info.main
    }
  }),
  { name: "PreviewOrderNotRefHeader" }
);
export default useStyles;
